import { render, staticRenderFns } from "./room-control-form.vue?vue&type=template&id=ff5e5564&"
import script from "./room-control-form.vue?vue&type=script&lang=ts&"
export * from "./room-control-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports